import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getArticles } from '../../redux/actions/article.action';
import Paginate from '../../components/Paginate';
import { setLoading } from '../../redux/actions/loader.action';
import axios from 'axios';
import { logout } from '../../redux/actions/auth.action';
import { dateFormat, endpoint, endpointApi } from '../../utils';
import QuillEditor from '../../components/QuillEditor';

export default function ArticlesPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const { me } = useSelector(state => state.auth);
    const articles = useSelector(state => state.articles);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const addModalRef = useRef(null);
    const updateModalRef = useRef(null);
    const detailsModalRef = useRef(null);
    const fileRef = useRef(null);
    const _fileRef = useRef(null);

    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);
    const [article, setArticle] = useState(null);
    
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [photo, setPhoto] = useState("");
    const [status, setStatus] = useState("");
    const [isTitleTouched, setIsTitleTouched] = useState("");
    const [isStatusTouched, setIsStatusTouched] = useState("");
    const [errors, setErrors] = useState(null);

    const handlePhotoChange = (e) => {
        const selectedPhoto = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result;
            setPhoto(base64String);
        };
    
        if (selectedPhoto) {
            reader.readAsDataURL(selectedPhoto);
        }
    }

    useEffect(() => {
        if(article && modal === 'update'){
            setTitle(article.title);
            setContent(article.content);
            setStatus(article.status);
            setPhoto("");

            if(fileRef.current)
                fileRef.current.value = null;

            if(_fileRef.current)
                _fileRef.current.value = null;
        }
    }, [modal, article]);

    useEffect(() => {
        dispatch(getArticles(location, navigate));
    }, [location, navigate, dispatch]);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        const clickOutsideModal = (e) => {
            if(addModalRef.current === e.target || updateModalRef.current === e.target  || detailsModalRef.current === e.target || e.target.classList.contains('_modal-close'))
            {
                setModal(null);
            }
        }
        document.addEventListener('click', clickOutsideModal);

        return () => {
            document.removeEventListener('click', clickOutsideModal);
        }
    }, []);

    useEffect(() => {
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            })
        }
    }, [modal]);

    useEffect(() => {
        if(modal === null){
            setTitle("");
            setContent("");
            setPhoto("");
            setStatus("");

            if(fileRef.current)
                fileRef.current.value = null;
            if(_fileRef.current)
                _fileRef.current.value = null;

            setIsTitleTouched(false);
            setIsStatusTouched(false);

            setErrors(null);
        }
    }, [modal]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        await axios.post(`${ endpointApi }articles`, data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        dispatch(getArticles(location, navigate));
                        setArticle(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }
    
    const handleSubmit2 = async (e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        await axios.post(`${ endpointApi }articles/${ article?.id }`, data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        dispatch(getArticles(location, navigate));
                        setArticle(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    useEffect(() => {
        if(!jwt_access){
          navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Articles - Société Mikalo</title>
            </Helmet>
            
            <Header />

            <Nav />

            <main id="main">
                <div className='title d-flex justify-content-between'>
                    <h1>Articles</h1>
                    <button type='button' onClick={ () => {
                        setModal('add');
                    } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
                </div>

                <div ref={ addModalRef } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Ajouter un article</h4>
                            <button type='button' className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='title' className='required'>Titre</label>
                                    <input type='text' id="title" name='title' placeholder='Titre' className='form-control' value={ title } required autoComplete='off' onChange={ (e) => setTitle(e.target.value) } onBlur={ () => setIsTitleTouched(true) } />
                                    { isTitleTouched && title.length === 0 && <div className='form-error'>Veuillez saisir le titre.</div> }
                                    { isTitleTouched && title.length > 0 && title.length < 2 && <div className='form-error'>Le titre est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.title && <div className='form-error'>{ errors.title[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='content' className='required'>Contenu</label>
                                    <QuillEditor onChange={ setContent } placeholder='Contenu' defaultValue={ content } />
                                    <textarea style={{ display: 'none' }} name='content' value={ content } onChange={ (e) => setContent(e.target.value) }></textarea>
                                    { errors && errors.content && <div className='form-error'>{ errors.content[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='photo' className='required'>Photo</label><br/>
                                    <input ref={ fileRef } type='file' id="photo" name='photo' required onChange={ handlePhotoChange } />
                                    { photo.length > 0 &&
                                    <div className='pt-2'>
                                        <div className='photo'>
                                            <img src={ photo } alt="" />
                                        </div>
                                    </div> }
                                    { errors && errors.photo && <div className='form-error'>{ errors.photo[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='status' className='required'>Statut</label>
                                    <select id="status" name='status' className='form-control' value={ status } required onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) }>
                                        <option value="">Sélectionner</option>
                                        <option value="0">En attente</option>
                                        <option value="1">Publié</option>
                                        <option value="2">Suspendu</option>
                                    </select>
                                    { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez Sélectionner le statut.</div> }
                                </div>

                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        title.length < 2 || content.length < 240 || photo === null || status.length === 0
                                    }><i className="fa fa-save"></i> Enregistrer</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                
                <div ref={ updateModalRef } className={ `_modal${ modal === 'update' && article ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Modifier un article</h4>
                            <button type='button' className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit2 }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='_title' className='required'>Titre</label>
                                    <input type='text' id="_title" name='title' placeholder='Titre' className='form-control' value={ title } required autoComplete='off' onChange={ (e) => setTitle(e.target.value) } onBlur={ () => setIsTitleTouched(true) } />
                                    { isTitleTouched && title.length === 0 && <div className='form-error'>Veuillez saisir le titre.</div> }
                                    { isTitleTouched && title.length > 0 && title.length < 2 && <div className='form-error'>Le titre est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.title && <div className='form-error'>{ errors.title[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_content' className='required'>Contenu</label>
                                    <QuillEditor onChange={ setContent } placeholder='Contenu' defaultValue={ content } />
                                    <textarea style={{ display: 'none' }} name='content' value={ content } required onChange={ (e) => setContent(e.target.value) }></textarea>
                                    { errors && errors.content && <div className='form-error'>{ errors.content[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_photo' className='required'>Photo</label><br/>
                                    <input ref={ _fileRef } type='file' id="_photo" name='photo' onChange={ handlePhotoChange } />
                                    { (photo.length > 0 || (article && article.photo)) &&
                                    <div className='pt-2'>
                                        <div className='photo'>
                                            <img src={ photo.length > 0 ? photo : endpoint + "storage/" + article.photo } alt="" />
                                        </div>
                                    </div> }
                                    { errors && errors.photo && <div className='form-error'>{ errors.photo[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_status' className='required'>Statut</label>
                                    <select id="_status" name='status' className='form-control' value={ status } required onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) }>
                                        <option value="">Sélectionner</option>
                                        <option value="0">En attente</option>
                                        <option value="1">Publié</option>
                                        <option value="2">Suspendu</option>
                                    </select>
                                    { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez Sélectionner le statut.</div> }
                                </div>

                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        title.length < 2 || content.length < 240 || status.length === 0 ||
                                        (modal === "update" && article && article.title && article.content === content && article.status === status && photo === "")
                                    }><i className="fa fa-save"></i> Mettre à jour</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                
                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && article ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { article &&
                            <h4>{ article.title }</h4> }
                            <button type='button' className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                        { article && <>
                            <div className='mb-3'>
                                <div className='_label'>Titre</div>
                                <div className='_value'>{ article?.title }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Contenu</div>
                                <div className='_value' dangerouslySetInnerHTML={{ __html: article?.content }}></div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Photo</div>
                                <div className='_value'>
                                    <div className='photo'>
                                        <img src={`${ endpoint }storage/${ article.photo }`} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Statut</div>
                                <div className='_value'>{ article.status === 0 ? <span className='badge bg-warning'>En attente</span> : (article.status === 1 ? <span className='badge bg-success'>Publié</span> : <span className='badge bg-danger'>Suspendu</span>) }</div>
                            </div>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Date de publication</div>
                                    <div className='_value'>{ dateFormat(article.created_at, 'short', true) }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Date de dernière modification</div>
                                    <div className='_value'>{ article.updated_at ? dateFormat(article.updated_at, 'short', true) : '-' }</div>
                                </div>
                            </div>
                            <div className='pt-2 text-center'>
                                <div className='btn btn-lg btn-primary' onClick={ () => {
                                    setModal('update')
                                }}><i className='fa fa-edit'></i> Modifier</div>
                            </div>
                        </> }
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                        <tr>
                            <th width="100">#ID</th>
                            <th width="100"></th>
                            <th>Titre</th>
                            <th width="160">Créé le</th>
                            <th width="140">Statut</th>
                            <th width="75" className="text-end">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            { articles.loading && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
                            { articles.loading === false && articles.data && articles.data.total === 0 && <tr><td colSpan={ 6 }>Aucun élément trouvé</td></tr> }
                            { articles.loading === false && articles.data && articles.data.data && articles.data.data.map((item, index) => {
                            return (
                            <tr key={ index }>
                                <td>#{ item.id }</td>
                                <td>
                                    <div className='img-thumbnail'>
                                        <img src={ `${ endpoint }storage/${ item.photo }` } alt="" />
                                    </div>
                                </td>
                                <td>{ item.title }</td>
                                <td>{ dateFormat(item.created_at, 'short', true) }</td>
                                <td>{ item.status === 0 ? <span className='badge bg-warning'>En attente</span> : (item.status === 1 ? <span className='badge bg-success'>Publié</span> : <span className='badge bg-danger'>Suspendu</span>) }</td>
                                <td className='text-end'>
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                            e.stopPropagation();
                                            setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                            <li><button onClick={ () => {
                                                setModal("details");
                                                setActionModal(null);
                                                setArticle(item);
                                            } }><i className='fa fa-eye'></i> Voir les détails</button></li>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setArticle(item);
                                                setModal("update");
                                            } }><i className='fa fa-edit'></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr> ) })}
                        </tbody>
                    </table>
                </div>
                    
                { articles && articles.data &&
                <Paginate currentPage={ articles.data.current_page } totalPages={ articles.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
